import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=b3575020&scoped=true"
import script from "./MyProfile.vue?vue&type=script&lang=js"
export * from "./MyProfile.vue?vue&type=script&lang=js"
import style0 from "./MyProfile.vue?vue&type=style&index=0&id=b3575020&prod&lang=css"
import style1 from "./MyProfile.vue?vue&type=style&index=1&id=b3575020&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3575020",
  null
  
)

export default component.exports